export const continueFromYoutubeDataSet = { cy: 'youtube-upload-modal-continue-btn' };
export const clearYoutubeUrlDataSet = { cy: 'clear-youtube-url-btn' };
export const youtubeUrlInputDataSet = { cy: 'youtube-input-url-btn' };
